/* Thin wrapper around `motion` — kept as the single import point so the
   underlying animation engine can be swapped for raw WAAPI later without
   touching call sites. */
import { animate, stagger } from "motion";

export { animate, stagger };

export function reducedMotion(): boolean {
  return typeof window !== "undefined" && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
}
